var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.plusPlans.length
    ? _c("div", { staticClass: "pricing-table-component" }, [
        _c("div", { staticClass: "plans" }, [
          _vm.isEnterprisePlan == true
            ? _c(
                "div",
                { staticClass: "pa-4 plan contrast" },
                [
                  _c("DynamicLogo", {
                    staticClass: "logo",
                    attrs: { plan: "enterprise" },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n      You are currently on PM2 Enterprise plan."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Current plan")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "infos-plan mt-2" }, [
                    _vm._v("\n        Type:"),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.currentPlan.name))]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v("\n        Plan Monthly Price:\n        "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(_vm._s(_vm.formatPlanPrice(_vm.currentPlan))),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v("\n        Process Limit number:"),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.currentPlan.process_limit))]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v("\n        Contact:"),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("sales@keymetrics.io")]),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                { class: (_vm.dark ? "contrast" : "base") + " pa-2 pt-4 plan" },
                [
                  _c("DynamicLogo", {
                    staticClass: "logo",
                    attrs: { plan: "plus" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "plan-expl" }, [
                    _c("p", { staticClass: "pm2-plus-tagline mt-3 mb-4" }, [
                      _vm._v(
                        "\n          Improve your Node.js application and check that it runs smoothly 24/24 7/7 with PM2\n          Plus:\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "features" },
                      [
                        _vm._l(_vm.incentives.plus, function (incentive) {
                          return _c(
                            "li",
                            { key: incentive.id },
                            [
                              _c("KmIcon", {
                                attrs: { name: incentive.route.meta.icon },
                              }),
                              _vm._v(
                                "  " + _vm._s(incentive.title) + "\n          "
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c("KmIcon", {
                              attrs: { size: 28, name: "km-icon-support" },
                            }),
                            _vm._v(" Zendesk Support Ticket"),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c("VIcon", { attrs: { color: "white" } }, [
                              _vm._v("mdi-clock"),
                            ]),
                            _vm._v("   14 days Data Retention"),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "price-zone" },
                    [
                      _c("h1", { staticClass: "price-title" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatPlanPrice(_vm.selectedPlusPlan))
                        ),
                        _c("small", [_vm._v("/month")]),
                      ]),
                      _vm._v(" "),
                      _c("VSlider", {
                        staticClass:
                          "pa-0 ma-0 px-5 no-disable slider-override",
                        attrs: {
                          min: "0",
                          max: _vm.plusPlans.length - 1,
                          alwaysDirty: true,
                          step: "1",
                          color: "info",
                          ticks: "",
                        },
                        model: {
                          value: _vm.processPlan,
                          callback: function ($$v) {
                            _vm.processPlan = $$v
                          },
                          expression: "processPlan",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-limit mb-2" }, [
                        _c("small", [_vm._v("Monitor up to")]),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.selectedPlusPlan.process_limit) +
                            " processes\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "yearly-switch" },
                        [
                          _vm.yearly
                            ? _c("small", [
                                _vm._v("\n            Yearly\n          "),
                              ])
                            : _c("small", [
                                _vm._v("\n            Monthly\n          "),
                              ]),
                          _vm._v(" "),
                          _c("VSwitch", {
                            staticClass: "no-top-space",
                            attrs: { hideDetails: "", color: "info" },
                            model: {
                              value: _vm.yearly,
                              callback: function ($$v) {
                                _vm.yearly = $$v
                              },
                              expression: "yearly",
                            },
                          }),
                          _vm._v(" "),
                          _vm.yearly
                            ? _c("small", [
                                _vm._v("\n            -20%\n          "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.plusButtonHint, function (line) {
                        return _c(
                          "div",
                          { key: line, staticClass: "plus--text" },
                          [_c("strong", [_vm._v(_vm._s(line))])]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "VBtn",
                        {
                          staticClass: "font-bold mt-2 mx-0 mb-0",
                          attrs: { color: "green" },
                          on: {
                            click: function ($event) {
                              return _vm.subscribe()
                            },
                          },
                        },
                        [_vm._v("\n          Subscribe to Plan\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.isPremiumBucket
                        ? _c(
                            "span",
                            {
                              staticClass: "unsubscribe",
                              attrs: { color: "error" },
                              on: {
                                click: function ($event) {
                                  return _vm.unsubscribe()
                                },
                              },
                            },
                            [_vm._v("\n          Unsubscribe\n        ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }